import Manage from "..";
import { useContext, useEffect, useState } from "react";

import Toastify from "toastify-js";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

import BookingPanel from "./components/BookingPanel";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import { pusher } from "../../..";
import BookingHeader from "./components/BookingHeader";
import moment from "moment";
import { Link } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";

export default function AllCalendar() {
  const { user, token, expire } = useContext(AuthContext);
  const [bookings, setBookings] = useState([]);
  const [selected, setSelected] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [dates, setDates] = useState<any>({
    startDate: moment(new Date()),
    endDate: moment(new Date()),
    isRange: false,
  });

  const site = user?.site?._id || "6224dcf60c5c49d9fec9218f";

  const renderEventContent = (eventInfo: any) => {
    return (
      <>
        {eventInfo?.event?._def?.extendedProps?.status === "Unconfirmed" ? (
          <button
            onClick={() => {
              setSelected(eventInfo?.event?._def);
              setShowPanel(true);
            }}
            className="bg-red-100 p-1 w-full hover:bg-red-200 "
          >
            {eventInfo.event.title
              ? eventInfo.event.title
              : eventInfo?.event?._def?.extendedProps?.vehicle}
          </button>
        ) : (
          <button
            onClick={() => {
              setSelected(eventInfo?.event?._def);
              setShowPanel(true);
            }}
            className="bg-green-100 p-1 w-full hover:bg-green-200 "
          >
            {eventInfo.event.title
              ? eventInfo.event.title
              : eventInfo?.event?._def?.extendedProps?.vehicle}
          </button>
        )}
      </>
    );
  };

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `bookings/smart/${site}?start=${moment(dates?.startDate).format(
      "YYYYMMDD"
    )}&end=${moment(dates?.endDate).format("YYYYMMDD")}&all=0`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchBookings();
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  const handleReFetchBookings = async ({ range }: any) => {
    setLoading(true);
    let uri = `bookings/smart/${site}?start=${moment(range?.startDate).format(
      "YYYYMMDD"
    )}&end=${moment(range?.endDate).format("YYYYMMDD")}&all=${
      range?.isAll ? 1 : 0
    }`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  const handleDateChange = async ({ range }: any) => {
    handleReFetchBookings({ range });
  };

  useEffect(() => {
    handleFetchBookings();
  }, []);

  return (
    <Manage
      title={"Bookings"}
      subtitle={"Recent"}
      hasLogo={true}
      description={"List of recent bookings"}
      actions={
        <>
          <Link to="/manage/bookings" className="flex items-center">
            <BsChevronLeft />
            <span className="ml-1">Back</span>
          </Link>
        </>
      }
    >
      <BookingHeader
        bookings={bookings}
        inManage={true}
        stateHandler={handleDateChange}
        handleFetchBookings={handleFetchBookings}
      />
      <div className="m-4">
        <FullCalendar
          plugins={[dayGridPlugin]}
          events={bookings}
          initialView="dayGridMonth"
          eventContent={renderEventContent}
        />
      </div>
      <BookingPanel
        isVisible={showPanel}
        setVisible={setShowPanel}
        selected={selected}
      />
    </Manage>
  );
}
